/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';

export default {
    GetProductDetails,
    GetAllGroups,
    getModeOfOperation,
    getAvailableCustomerTypes,
    GetOutletsByCustomerTypeID,
    GetProductCategoties,
    GetFactoriesByGroupID,
    GetProductsByFactoryIDProductcatogeryID,
    GetCustomerOutletWiseOrderHistoryReportData,
    GetFDCFactoriesByGroupID
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response.data;
}

async function GetAllGroups() {
    const response = await CommonGet('/api/Group/GetAllGroups', null);
    return response.data;
}

async function getModeOfOperation() {
    const response = await CommonGet('/api/CustomerMaster/GetModeOfOperation', null);
    return response.data;
}

async function getAvailableCustomerTypes() {
    const response = await CommonGet('/api/CustomerMaster/GetCustomerTypes', null);
    return response.data;
}

async function GetOutletsByCustomerTypeID(groupID, customerTypeID) {
    const response = await CommonGet('/api/OutboundInvoice/GetOutletsByCustomerTypeID', 'groupID=' + parseInt(groupID) + '&customerTypeID=' + parseInt(customerTypeID));
    return response.data;
}

async function GetFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetProductsByFactoryIDProductcatogeryID(factoryID, productcatogeryID) {
    const response = await CommonGet('/api/Product/GetProductsByFactoryIDProductcatogeryIDMultiSelect', 'factoryID=' + factoryID + '&productcatogeryID=' + productcatogeryID);
    return response.data;
}

async function GetCustomerOutletWiseOrderHistoryReportData(groupID, modeofOperationID, customerTypeID, operationEntityID, productCategoryID, productID, fromDate, toDate) {
    let model = {
        groupID: parseInt(groupID),
        modeofOperationID: parseInt(modeofOperationID),
        customerTypeID: parseInt(customerTypeID),
        operationEntityID: Array.isArray(operationEntityID) ? operationEntityID.join(',') : '',
        productCategoryID: Array.isArray(productCategoryID) ? productCategoryID.join(',') : '',
        productID: Array.isArray(productID) ? productID.join(',') : '',
        fromDate: fromDate,
        toDate: toDate
    }
    const response = await CommonPost('/api/CustomerOutletWiseOrderHistoryReport/GetCustomerOutletWiseOrderHistoryReportData', null, model);
    return response.data;

}

async function GetFDCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/QuantityVarianceReport/GetFDCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

